<template lang="pug">
  .pho-text-field
    PhoValidationProvider(:rules="rules" :name="validationName")
      v-text-field(
        v-model="lazyValue"
        v-on="$listeners"
        spellcheck="false"
        :label="label"
        :maxlength="maxCharacterLength"
        :counter="maxCharacterLength"
        :readonly="readonly"
        :disabled="disabled"
        :hide-details="hideDetails"
        :outlined="outlined"
        :dense="dense"
        :prepend-icon="prependIcon"
        :append-icon="appendIcon"
        :placeholder="placeholder"
      )
</template>

<script>
import { computed } from 'vue';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import PhoValidationProvider from './PhoValidationProvider.vue';

export default {
  name: 'PhoTextField',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    maxCharacterLength: {
      type: Number,
      default: null,
    },
    rules: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    prependIcon: {
      type: String,
    },
    appendIcon: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);

    const validationName = computed(() => props.name || props.label);

    return {
      lazyValue,
      validationName,
    };
  },
};
</script>
